module.exports = __webpack_public_path__ + "statics/img/green.5472a830.png";